import { render, staticRenderFns } from "./playersTurn.vue?vue&type=template&id=08953e1c&scoped=true&"
import script from "./playersTurn.vue?vue&type=script&lang=js&"
export * from "./playersTurn.vue?vue&type=script&lang=js&"
import style0 from "./playersTurn.vue?vue&type=style&index=0&id=08953e1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08953e1c",
  null
  
)

export default component.exports